<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="CT" id="_idParaDest-5"><span class="CharOverride-2">C</span><span class="CT-SC CharOverride-13">ONTENTS</span></p>
<p class="BT ParaOverride-9"><a href="#/eBook_V2891#_idTextAnchor000"><span class="CharOverride-14">Beyond the Rivers of Ethiopia</span></a></p>
<p class="BT ParaOverride-10"><a href="#/eBook_V28917#_idTextAnchor001"><span class="CharOverride-14">Take Me Home to Mama</span></a></p>
<p class="BT ParaOverride-10"><span href="#/eBook_V28918#_idTextAnchor002" title="Link target outside of Sample"><span class="CharOverride-14">Journalist Plus Plus</span></span></p>
<p class="BT ParaOverride-10"><span href="#/eBook_V28919#_idTextAnchor003" title="Link target outside of Sample"><span class="CharOverride-14">The Zanzibar Chest</span></span></p>
<p class="BT ParaOverride-10"><span href="#/eBook_V289110#_idTextAnchor004" title="Link target outside of Sample"><span class="CharOverride-14">Feeding the Beast</span></span></p>
<p class="BT ParaOverride-10"><span href="#/eBook_V289111#_idTextAnchor005" title="Link target outside of Sample"><span class="CharOverride-14">Going Native</span></span></p>
<p class="BT ParaOverride-10"><span href="#/eBook_V289112#_idTextAnchor006" title="Link target outside of Sample"><span class="CharOverride-14">The Sound of Freedom in the Air</span></span></p>
<p class="BT ParaOverride-10"><span href="#/eBook_V289113#_idTextAnchor007" title="Link target outside of Sample"><span class="CharOverride-14">Empty Quarter</span></span></p>
<p class="BT ParaOverride-10"><span href="#/eBook_V289114#_idTextAnchor008" title="Link target outside of Sample"><span class="CharOverride-14">Lazarus</span></span></p>
<p class="BT ParaOverride-10"><span href="#/eBook_V289115#_idTextAnchor009" title="Link target outside of Sample"><span class="CharOverride-14">One Moment, of the Well of Life to Taste</span></span></p>
<p class="BT ParaOverride-10"><span href="#/eBook_V289116#_idTextAnchor010" title="Link target outside of Sample"><span class="CharOverride-14">Herograms</span></span></p>
<p class="BT ParaOverride-10"><span href="#/eBook_V289117#_idTextAnchor011" title="Link target outside of Sample"><span class="CharOverride-14">Postscript</span></span></p>
<p class="BT ParaOverride-10"><span href="#/eBook_V289118#_idTextAnchor012" title="Link target outside of Sample"><span class="CharOverride-14">Acknowledgments</span></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eBook_V28914.vue?123be595